import { COOKIE_KEY } from 'constants/browserCache';
import { getCookieItem } from 'utils/browserCache';
import { JsonEditor } from '../JsonEditor';

export const CookieDebug = () => {
  return (
    <>
      {Object.values(COOKIE_KEY)
        .map((cookie) => {
          const data = getCookieItem(cookie);
          if (!data) return null;

          return <JsonEditor key={cookie} rootName={cookie} data={{ [cookie]: data }} />;
        })
        .filter(Boolean)}
    </>
  );
};
